import React from 'react';
import { Route } from 'react-router-dom'

import { Header, Footer } from '../partials';
import { ErrorPage } from '../errorPage';
import './layouts.css';

class UnauthedLayout extends React.Component {   
    render(){
        return (
            <div className="layout unauthed-layout">
                <Header />
                <div className="main-content">
                    <Route path="/error" component={ErrorPage} />
                </div>
                <Footer />
            </div>
        );
    }
}

export default UnauthedLayout;


// WEBPACK FOOTER //
// ./src/components/layouts/UnauthedLayout.jsx